var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListPanel',{attrs:{"mode":"pending","fetch-list":_vm.fetchPendingList}})
}
var staticRenderFns = []

export { render, staticRenderFns }